import jwt_decode from 'jwt-decode';
import Moment from 'moment';
import Vue from 'vue';

import { LocalStorageService } from '@/services/local-storage.service';
import { AUTH_STORAGE_KEYS } from '../values/auth.values';
import { AuthPrivileges } from '../models/auth-privileges.model';
import { ITokenPayload } from '../interfaces/auth.interface';

class AuthProviderClass extends Vue {
  getToken(): string {
    return LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);
  }
  
  getTokenInfo(): ITokenPayload {
    const isTokenActive = this.getIsCurrentAccessTokenActive();

    if (!isTokenActive) {
      throw new Error('Token is not active');
    }

    const accessToken = LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);
    return jwt_decode(accessToken);
  }

  getIsCurrentAccessTokenActive(): boolean {
    const accessToken = LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT);

    return this.getIsTokenActive(accessToken);
  }

  getIsTokenActive(accessToken: string): boolean {
    let active = false;
    try {
      if(accessToken) {
        const decoded: any = jwt_decode(accessToken);
        const expDate = Moment(decoded.exp * 1000);
        active = Moment().isBefore(expDate);
      }
      return active;
    } catch(error) {
      active = false
      return active;
    }
  }

  getRolesFromAccessToken(): string[] {
    const startWith = 'ROLE_';
    const tokenInfo = this.getTokenInfo();
    const roles: string[] = [];
    const authorities = tokenInfo.authorities;

    if (tokenInfo) {
      for (const authority of authorities) {
        if (authority.startsWith(startWith)) {
          roles.push(authority.replace(startWith, ''));
        }
      }
    }

    return roles;
  }

  getPrivilegesFromAccessToken(): AuthPrivileges {
    const tokenInfo = this.getTokenInfo();
    const authorities = tokenInfo?.authorities || [];

    return new AuthPrivileges(authorities);
  }

  isUserAllowed(rolesNotAllowed: string[]): boolean {
    const isUserLogged = this.getIsCurrentAccessTokenActive();

    if (isUserLogged) {
      const userRoles = this.getRolesFromAccessToken();

      return !rolesNotAllowed.some((roleNotAllowed) => {
        return userRoles.includes(roleNotAllowed);
      });
    }

    return true;
  }
}

export const AuthProvider = new AuthProviderClass();